import axios from 'axios';
import { WaterInfo } from 'components/forms/TaxSearches/NJTaxSearch/types';
import produce from 'immer';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Icon } from 'semantic-ui-react';
import Button from 'components/ui/Button';
import { toast } from 'react-toastify';
import { initialTaxSearchValues, initialWaterInfo, SearchInfo, TaxSearchValues } from './types';
import { WaterFormHeader } from './WaterFormHeader';
import { WaterFormBody } from './WaterFormBody';

interface Params {
  taskId?: string;
}

export const NjInPersonMunicipalityForm = () => {
  const [searchInfo, setSearchInfo] = useState<SearchInfo>(null);
  const [water, setWater] = useState([initialWaterInfo]);
  const [taxSearchValues, setTaxSearchValues] = useState<TaxSearchValues>(initialTaxSearchValues);
  const [expandedWaterIndex, setExpandedWaterIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [gotSaved, setGotSaved] = useState(false);
  const params = useParams<Params>();
  const history = useHistory();

  useEffect(() => {
    getSearchInformation();
  }, []);

  useEffect(() => {
    if (searchInfo && searchInfo.propertyId) {
      getSaved();
    }
  }, [searchInfo]);

  const getSearchInformation = async () => {
    axios.get(`/api/searches/getTaxSearchInfo/${params.taskId}`).then(({ data }) => {
      setSearchInfo(data);
    });
  };

  const getSaved = async () => {
    axios
      .get<TaxSearchValues>(`/api/searches/getSaved?propertyId=${searchInfo.propertyId}&searchTypeId=20`)
      .then(({ data }) => {
        if (data) {
          const newData = { ...taxSearchValues, ...data };
          setTaxSearchValues(newData);
          setWater(newData.water);
        }
        setGotSaved(true);
      });
  };

  const changeWaterInfo = (waterIndex: number, label: keyof WaterInfo, value: any) => {
    const newWater = produce(water, draft => {
      (draft[waterIndex][label] as any) = value;
    });
    setWater(newWater);
  };

  const deleteWater = (indexToRemove: number) => {
    const newWaters = water.filter((w, index) => index !== indexToRemove);
    setWater(newWaters);
  };

  const addWater = () => {
    const addedWater = initialWaterInfo;
    const newIndex = water.length;
    const newWater = produce(water, draft => {
      draft.push(addedWater);
    });
    setWater(newWater);
    setExpandedWaterIndex(newIndex);
  };

  const handleSave = async () => {
    setIsLoading(true);
    const formData = {
      ...taxSearchValues,
      water,
      propertyId: searchInfo.propertyId,
      taskId: +params.taskId,
    };
    await axios
      .post('/api/searches/saveSearchFormData', {
        data: { ...formData },
      })
      .then(() => {
        setIsLoading(false);
        toast('Info Saved Successfully', {
          hideProgressBar: true,
          position: 'bottom-right',
          type: 'success',
          autoClose: 1000,
        });
        history.replace('/reports/types/nj-in-person-municipality-queue');
      });
  };

  const toggleSectionExpanded = (index: number) => {
    setExpandedWaterIndex(expandedWaterIndex === index ? -1 : index);
  };

  return (
    <div>
      {gotSaved && (
        <>
          <WaterFormHeader searchInfo={searchInfo} />
          <div
            style={{ borderBottom: '1px solid #e5e5ea', paddingBottom: 32, marginTop: 32 }}
            id="Water/Sewer"
          >
            <div style={{ fontSize: 18, fontWeight: 900 }}>Water/Sewer</div>
            {water.map((w, waterIndex) => (
              <WaterFormBody
                waterIndex={waterIndex}
                w={w}
                propertyInfo={taxSearchValues.propertyInfo}
                expandedWaterIndex={expandedWaterIndex}
                toggleSectionExpanded={toggleSectionExpanded}
                deleteWater={deleteWater}
                changeWater={changeWaterInfo}
              />
            ))}
            <div
              style={{
                cursor: 'pointer',
                display: 'flex',
                marginTop: 24,
                marginBottom: 15,
                justifyContent: 'space-between',
              }}
            >
              <div onClick={addWater}>
                <Icon name="plus" />
                <span style={{ fontWeight: 'bold', marginLeft: 4 }}>Add Water/Sewer</span>
              </div>
              <Button onClick={handleSave} loadingStatus={isLoading}>
                Submit
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
